import { Button, Box, Grid, Typography } from '@mui/material';
import { CloudUpload } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { storage } from '../../../config/firebase';
import { getDownloadURL, ref, uploadBytes, deleteObject } from 'firebase/storage';
import Resizer from 'react-image-file-resizer';
import * as React from 'react';

// Move styled component outside to prevent recreation on every render
const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

export const NodeImageUploader = (props) => {
    const { node, projectId, updateImage } = props;
    const [imageUrl, setImageUrl] = React.useState(node?.data?.image ?? "");
    const [isUploading, setIsUploading] = React.useState(false);
    const [isDeleting, setIsDeleting] = React.useState(false);

    // Sync state with prop changes
    React.useEffect(() => {
        const newImageUrl = node?.data?.image ?? "";
        setImageUrl(newImageUrl);
    }, [node?.data?.image]);

    const handleButtonClick = React.useCallback(async () => {
        // Delete the image from Firebase Storage if it exists
        if (!imageUrl || imageUrl === "") return;
        
        setIsDeleting(true);
        try {
            const imageRef = ref(storage, `projects/${projectId}/${node.data.id}.jpeg`);
            await deleteObject(imageRef);
            console.log("Image deleted from storage");
        } catch (error) {
            // If the file doesn't exist or deletion fails, log but continue
            // This handles cases where the file was already deleted or doesn't exist
            console.log("Error deleting image from storage:", error);
        } finally {
            setIsDeleting(false);
        }
        
        // Clear the image URL from state and update the node
        setImageUrl("");
        updateImage("");
    }, [imageUrl, projectId, node?.data?.id, updateImage]);

    const uploadImage = React.useCallback(async (uri) => {
        if (!uri) return;

        try {
            setIsUploading(true);
            const blob = await fetch(uri).then((r) => r.blob());
            const fileFromBlob = new File([blob], `${node.data.id}.jpeg`, { type: 'image/jpeg' });
            const imageRef = ref(storage, `projects/${projectId}/${node.data.id}.jpeg`);

            await uploadBytes(imageRef, fileFromBlob);
            const url = await getDownloadURL(imageRef);
            setImageUrl(url);
            updateImage(url);
        } catch (error) {
            console.error("Error uploading image:", error);
            // Optionally show error to user
        } finally {
            setIsUploading(false);
        }
    }, [projectId, node?.data?.id, updateImage]);

    const resizeAndUploadPic = React.useCallback((file) => {
        if (!file) return;
        
        Resizer.imageFileResizer(
            file,
            128,
            128,
            "JPEG",
            80,
            0,
            (resizedPicUri) => {
                uploadImage(resizedPicUri);
            },
            "base64",
            64,
            64
        );
    }, [uploadImage]);

    const handleFileChange = React.useCallback((event) => {
        const file = event.target.files?.[0];
        if (file) {
            resizeAndUploadPic(file);
        }
        // Reset input value to allow re-uploading the same file
        event.target.value = '';
    }, [resizeAndUploadPic]);

    return (
        <Grid
  container
  spacing={0}
  direction="column"
  alignItems="center"
  justifyContent="center"
>
  <Grid 
    item 
    container 
    direction="column" 
    alignItems="center" 
    justifyContent="center"
    sx={{ width: "100%" }}
  >
    <Grid item>
      {imageUrl ? (
        <Box
          component="img"
          sx={{
            height: 100,
            width: 100,
            objectFit: "cover",
            display: "block",
            margin: "0 auto",
            borderRadius: "8px",
            border: "1px solid #ccc",
            bgcolor: "#fafafa"
          }}
          alt="Node"
          src={imageUrl}
        />
      ) : (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{
            height: 100,
            width: 100,
            bgcolor: "#ececec",
            borderRadius: "8px",
            border: "1px dashed #ccc"
          }}
        >
          <Typography
            variant="caption"
            color="textSecondary"
            sx={{ width: "100%", textAlign: "center" }}
          >
            No image set
          </Typography>
        </Box>
      )}
    </Grid>
    {/* <Grid item>
      <Button
        component="label"
        fullWidth
        sx={{ mt: "15px" }}
        role={undefined}
        variant="contained"
        tabIndex={-1}
        startIcon={<CloudUpload />}
        disabled={isUploading || isDeleting}
      >
        {isUploading ? "Uploading..." : "Upload Image"}
        <VisuallyHiddenInput 
          type="file" 
          accept="image/jpeg, image/png"
          onChange={handleFileChange}
        />
      </Button>
    </Grid>
    <Grid item>
      <Button 
        fullWidth 
        sx={{ mt: "5px" }} 
        onClick={handleButtonClick}
        disabled={!imageUrl || isUploading || isDeleting}
      >
        {isDeleting ? "Deleting..." : "Delete Image"}
      </Button>
    </Grid> */}
  </Grid>
</Grid>
        
    );
};